import API from './api';

export default class Option extends API {
  constructor(config = {}) {
    config.path = `quizzes/${config.quizId}/steps/${config.stepId}/options`;

    super(config);
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/request/option.js
 **/